.nav {
  display: flex;
  flex: none;
  flex-direction: column;
  align-items: center;
  width: var(--nav-width-icon);
  padding: var(--space-3) 0;
  color: var(--text-on-nav);
  background: var(--bg-nav);
}

.brand {
  flex: none;
  margin-bottom: var(--space-2);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-nav-active);
}

.list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
  align-items: center;
  min-height: 0;
  overflow-y: auto;
}

.item {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 36px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-nav);
  text-decoration: none;
  background: transparent;
  border-radius: var(--radius-md);
}

.item:hover {
  color: var(--text-on-nav-active);
  background: var(--bg-nav-hover);
}

.itemActive {
  color: var(--text-on-nav-active);
  background: var(--bg-nav-active);
  box-shadow: inset 3px 0 0 var(--nav-accent);
}

.dot {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 6px;
  height: 6px;
  background: var(--nav-accent);
  border-radius: 50%;
}

.footer {
  position: relative;
  flex: none;
  margin-top: auto;
  padding-top: var(--space-2);
}

.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--bg-nav);
  cursor: pointer;
  background: var(--nav-accent);
  border: 0;
  border-radius: 50%;
}

/* Меню профиля открывается ВВЕРХ от аватара: он стоит в самом низу полосы,
   и список, растущий вниз, оказался бы за краем окна. */
.menu {
  top: auto;
  bottom: calc(100% + 4px);
  left: calc(100% + var(--space-2));
  width: 240px;
}
